export function Select({id,label,subLabel,options,name,defaultValue,  onChange,style}){
	const selectOptions = options.map((entry,index)=> <option  key={index}>{entry}</option>)
	return (
		<div id={id} className="select-input-div" style={style}>
			<label>{label} <span className="subLabel">{subLabel}</span></label>
			<select name={name} defaultValue={defaultValue} onChange={onChange}>
				{selectOptions}
			</select>
		</div>
	)
}